import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface IToastState {
  toastData: {
    type?: "success" | "warning" | "danger" | "info";
    mess: string;
    sub: string;
    offSetBottom: number | null;
    interpolation: { [key: string]: unknown };
  };
}

const initialState: IToastState = {
  toastData: {
    type: undefined,
    mess: "",
    sub: "",
    offSetBottom: null,
    interpolation: {},
  },
};

const setToastAction = (
  state: IToastState,
  action: PayloadAction<{
    type?: "success" | "warning" | "danger" | "info";
    mess: string;
    sub?: string;
    offSetBottom?: number;
    interpolation?: { [key: string]: unknown };
  }>
) => {
  const { type, mess, sub, offSetBottom, interpolation } = action.payload;
  state.toastData = {
    type,
    mess,
    sub: sub || "",
    offSetBottom: offSetBottom ?? null,
    interpolation: interpolation ?? {},
  };
};

export const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    setToast: setToastAction,
  },
});

export const { setToast } = toastSlice.actions;

export const selectToastData = (state: RootState) => state.toast.toastData;

export default toastSlice.reducer;
